var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogAddLaw__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("שיוך תקציר פסיקה ליחידת לימוד"),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "DialogAddLaw__Component__Loading" },
          [
            _c(
              "b-field",
              { attrs: { label: "הזן שם" } },
              [
                _c("b-input", {
                  model: {
                    value: _vm.model.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "name", $$v)
                    },
                    expression: "model.name",
                  },
                }),
              ],
              1
            ),
            _c("FieldInlineSelect", {
              attrs: {
                label: "יחידת לימוד",
                filterable: true,
                clearable: true,
                optionsAsync: _vm.getLessons,
              },
              on: { onChange: _vm.onChange },
              model: {
                value: _vm.model.lessonId,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "lessonId", $$v)
                },
                expression: "model.lessonId",
              },
            }),
            _c("FieldInlineSelect", {
              attrs: {
                label: "קטגוריה",
                filterable: true,
                clearable: true,
                optionsAsync: _vm.getCategories,
              },
              on: { onChange: _vm.onChange },
              model: {
                value: _vm.model.exerciseCategoryId,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "exerciseCategoryId", $$v)
                },
                expression: "model.exerciseCategoryId",
              },
            }),
            _c("FieldInlineSelect", {
              attrs: {
                label: "חוק",
                filterable: true,
                clearable: true,
                optionsAsync: _vm.getLaws,
              },
              on: { onChange: _vm.onChange },
              model: {
                value: _vm.model.lawId,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "lawId", $$v)
                },
                expression: "model.lawId",
              },
            }),
            _c("FieldInlineSelect", {
              attrs: {
                label: "תקציר פסיקה",
                filterable: true,
                clearable: true,
                optionsAsync: _vm.getVerdictSummaries,
              },
              on: { onChange: _vm.onChange },
              model: {
                value: _vm.model.verdictSummaryId,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "verdictSummaryId", $$v)
                },
                expression: "model.verdictSummaryId",
              },
            }),
            _c(
              "b-field",
              { attrs: { label: "סטטוס" } },
              [
                _c(
                  "b-select",
                  {
                    model: {
                      value: _vm.model.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "status", $$v)
                      },
                      expression: "model.status",
                    },
                  },
                  [
                    _c("option", { attrs: { value: "1" } }, [_vm._v("1")]),
                    _c("option", { attrs: { value: "0" } }, [_vm._v("0")]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "סדר" } },
              [
                _c("b-input", {
                  attrs: { type: "number" },
                  model: {
                    value: _vm.model.sortOrder,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "sortOrder", $$v)
                    },
                    expression: "model.sortOrder",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              label: "שמור",
              type: "is-primary",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }